// client/src/components/layout/Preloader.js
import React from 'react';
import './Preloader.css';

const Preloader = ({ isExiting = false }) => {
  return (
    <div
      className={`preloader ${isExiting ? 'preloader-exit' : ''}`}
      role="status"
      aria-live="polite"
      aria-label="Loading Makah Medics"
    >
      <div className="preloader-ambient-glow"></div>

      <div className="preloader-content">
        <div className="preloader-emblem-wrapper">
          <div className="orbital-ring ring-outer"></div>
          <div className="orbital-ring ring-inner"></div>
          <div className="pulse-halo"></div>
          <div className="preloader-logo-circle">
            <img
              src="/images/makah-medics-logo.jpeg"
              alt="Makah Medics"
              className="preloader-logo"
            />
          </div>
        </div>

        <div className="preloader-brand">
          <h1 className="preloader-title">MAKAH MEDICS</h1>
          <p className="preloader-subtitle">For a Healthy Society</p>
        </div>

        {/* Animated ECG / Medical Pulse Line */}
        <div className="ecg-wave-container" aria-hidden="true">
          <svg
            className="ecg-svg"
            viewBox="0 0 300 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="ecg-baseline"
              d="M0 25 H90 L105 25 L115 10 L127 42 L140 6 L152 38 L162 20 L172 25 H300"
            />
            <path
              className="ecg-pulse"
              d="M0 25 H90 L105 25 L115 10 L127 42 L140 6 L152 38 L162 20 L172 25 H300"
            />
          </svg>
        </div>

        <div className="preloader-progress-track" aria-hidden="true">
          <div className="preloader-progress-fill"></div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
